(() => {
  const syncDot = (dot) => {
    if (!(dot instanceof Element) || !dot.matches('[data-sok-dot]')) return;
    const selected = dot.getAttribute('aria-selected');
    if (selected === 'true') dot.setAttribute('aria-current', 'true');
    else if (selected === 'false') dot.removeAttribute('aria-current');
    if (selected !== null) dot.removeAttribute('aria-selected');
  };

  const syncAboutLabel = (root = document) => {
    const lang = (document.documentElement.lang || '').toLowerCase();
    if (lang && !lang.startsWith('en')) return;
    root.querySelectorAll('a[href*="/pages/about-us"]').forEach((link) => {
      if (link.closest('.sok-site-nav') || link.closest('.sok-site-drawer')) link.textContent = 'About SOK';
    });
  };

  const install = (root = document) => {
    root.querySelectorAll('[data-sok-carousel]').forEach((carousel) => {
      const dots = [...carousel.querySelectorAll('[data-sok-dot]')];
      dots.forEach(syncDot);
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'aria-selected') syncDot(mutation.target);
        });
      });
      dots.forEach((dot) => observer.observe(dot, { attributes: true, attributeFilter: ['aria-selected'] }));
    });
    syncAboutLabel(root);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => install(), { once: true });
  else install();
  document.addEventListener('shopify:section:load', (event) => install(event.target));
})();
